import { guid } from "./utils/guid";
import { getCookie, setCookie } from "./utils/cookies";
import { getQueryParam } from "./utils/query_params";

/**
 * Look for a device identification received as query parameter, or looks into a cookie or localStorage.
 * Then saved in on cookie and localStorage. If not exist generates one and saves cookie and localStorage.
 * @param idName Name of the key for a query parameter, cookie or localStorage to find the deviceID
 * @returns the device identification
 */
export function getId(idName) {
  const qsMusementId = getQueryParam(idName);
  const cookieMusementId = getCookie(idName);
  const localStorageMusementId = localStorage.getItem(idName);

  const cookieSettings = {
    name: idName,
    expireInDays: 1825,
  };

  /*
   * Values priority:
   * 1. query string - musementId=XXXX always overwrites cookie and localstorage
   * 2. cookie - cookie always overwrites localstorage
   * 3. localstorage - when cookie is not set but localstorage is present use that as musementId
   * 4. New GUID value
   */
  // 1. query string
  if (qsMusementId) {
    setCookie({
      ...cookieSettings,
      value: qsMusementId,
    });
    localStorage.setItem(idName, qsMusementId);
    return qsMusementId;

    // 2. cookie
  } else if (cookieMusementId != null) {
    if (localStorageMusementId !== cookieMusementId) {
      localStorage.setItem(idName, cookieMusementId);
    }
    return cookieMusementId;

    // 3. localstorage
  } else if (localStorageMusementId != null) {
    setCookie({
      ...cookieSettings,
      value: localStorageMusementId,
    });
    return localStorageMusementId;

    // 4. new GUID value
  } else {
    const id = guid();
    setCookie({
      ...cookieSettings,
      value: id,
    });
    localStorage.setItem(idName, id);
    return id;
  }
}
